module.exports = __webpack_public_path__ + "img/content4-3.71bcc61d.webp";